import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {isMobile} from '@netx/core-next/utils/browser';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';

export const canViewStats = () => {
	if (isMobile()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.DIRECTOR)) return false;
	return currentUserHasAccess(PermissionName.VIEW_STATISTICS);
};
